// ======================================================================
// File: src/modules/ipe/enquiry/pages/EnquiryDetailPage.js
// ======================================================================

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import ipeEnquiryService from "../../services/ipeEnquiryService";

//import EngineeringBOMView from "../../engineering/bom/EngineeringBOMView";
import EngineeringBOMCard from "../../engineering/bom/EngineeringBOMCard";
import EngineeringMOMView from "../../engineering/mom/EngineeringMOMView";
import BOMOperationMappingView from "../../engineering/material_operation/BOMOperationMappingView";

import axiosClient from "../../../../api/axiosClient";
import KpiCard from "../../components/common/KpiCard";
import CostingOverlayDrawer from "../../costing/CostingOverlayDrawer";
import ManufacturerMappingScreen from "../../engineering/bom/ManufacturerMappingScreen";
import SellingCostingOverlayDrawer from "../../costing/SellingCostingOverlayDrawer";
import SellingQuotationOverlayDrawer from "../../quotation/SellingQuotationOverlayDrawer";
import EngineeringBOMStructuredView from "../../engineering/bom/EngineeringBOMStructuredView";
// Optional future mapping view
//import MaterialOperationMappingView 
//  from "../../engineering/bom/MaterialOperationMappingView";

// ----------------------------------------------------------------------
// Local status mapping
// ----------------------------------------------------------------------
const STATUS_MAP = {
  1: "Draft",
  2: "Engineering Study",
  3: "BOM Preparation",
  4: "Cost Estimation",
  5: "Quotation Sent",
  6: "Closed",
};

export default function EnquiryDetailPage() {

  const { enquiryId } = useParams();
  const navigate = useNavigate();

  const [enquiry, setEnquiry] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("OVERVIEW");
  const [showCosting, setShowCosting] = useState(false);
  const [showSellingCost, setShowSellingCost] = useState(false);
  const [showQuotation, setShowQuotation] = useState(false);
  const [bomHeaders, setBomHeaders] = useState([]);

  const [selectedMappingItemId, setSelectedMappingItemId] = useState(null);
  const [variantMap, setVariantMap] = useState({});
  const [equipmentMap, setEquipmentMap] = useState({});
  const [allowedTransitions, setAllowedTransitions] = useState([]);
  const [accessControl, setAccessControl] = useState(null);

  
  // ------------------------------------------------------------------
  // Add Item modal state
  // ------------------------------------------------------------------

  const [showAddItem, setShowAddItem] = useState(false);

  const [newItem, setNewItem] = useState({
  item_seq_no: 1,
  product_family_id: "",
  product_variant_id: "",
  equipment_id: "",
  quantity: "",
  priority: 3,
});

  const [productFamilies, setProductFamilies] = useState([]);
  const [productVariants, setProductVariants] = useState([]);
  const [equipmentList, setEquipmentList] = useState([]);

  // ------------------------------------------------------------------
  // Add Product Variant modal state
  // ------------------------------------------------------------------

  const [showAddVariant, setShowAddVariant] = useState(false);

  const [newVariant, setNewVariant] = useState({
    variant_code: "",
    variant_name: "",
    variant_type: "STANDARD",
    uom_id: "",
    drawing_required: false,
  });

  const loadBOMHeaders = async (actualEnquiryId) => {
  try {
    console.log("➡️ Loading BOMs from enquiry:", actualEnquiryId);

    const res = await axiosClient.get(`/api/ipe/boms/enquiry/${actualEnquiryId}`);

    const bomHeadersData = (res.data?.data || []).map(b => ({
      id: b.id,
      code: b.bom_code || `BOM-${b.id}`
    }));

    console.log("FINAL BOM HEADERS:", bomHeadersData);

    setBomHeaders(bomHeadersData);

  } catch (err) {
    console.error("❌ Failed to load BOM headers", err);
    setBomHeaders([]);
  }
};
const handleGenerateAllDerived = async () => {
  try {

    if (!bomHeaders || bomHeaders.length === 0) {
      alert("No BOM available");
      return;
    }

    for (const bom of bomHeaders) {
      await axiosClient.post(`/api/ipe/boms/${bom.id}/generate-derived`);
    }

    alert("Derived BOM generated successfully");

    // 🔥 CRITICAL FIX (ADD THESE 2 LINES)
    await loadBOMHeaders(enquiry.id);  // refresh headers
    await loadItems();        // refresh BOM card UI

  } catch (err) {
    console.error(err);
    alert(err?.response?.data?.message || "Failed to generate derived");
  }
};

const handleGenerateDerived = async (bomId) => {
  try {
    if (!bomId) {
      alert("No BOM available");
      return;
    }

    await axiosClient.post(`/api/ipe/boms/${bomId}/generate-derived`);

    alert("Derived BOM generated successfully");

    // 🔥 IMPORTANT: reload BOM headers
    //await loadBOMHeaders();
    await loadBOMHeaders(enquiry.id);
  } catch (err) {
    console.error(err);
    alert(err?.response?.data?.message || "Failed to generate derived");
  }
};
  const loadAccessControl = async () => {

    const res = await axiosClient.get("/api/ipe/workflow/access-control", {
      params: {
        module_code: "IPE",
        entity_name: "ENQUIRY",
        entity_id: enquiryId
      }
    });

    console.log("ACCESS CONTROL:", res.data.data);

    setAccessControl(res.data.data);
  };
  // ------------------------------------------------------------------
  // Load enquiry items
  // ------------------------------------------------------------------

  const loadItems = async () => {

  const res = await ipeEnquiryService.listEnquiryItems(enquiryId);

  setItems(res?.items || []);

};



// ------------------------------------------------------------------
// LOAD TRANSITIONS
// ------------------------------------------------------------------

  const loadTransitions = async (statusCode) => {

    if (!statusCode) return;

    try {

      const res = await axiosClient.get("/api/ipe/workflow/transitions", {
        params: {
          module_code: "IPE",
          entity_name: "ENQUIRY",
          current_status: statusCode,
        },
      });

      setAllowedTransitions(res.data.data || []);

    } catch (err) {
      console.error("Transition load failed", err);
    }

  };

  // ------------------------------------------------------------------
  // HANDLE TRANSITION
  // ------------------------------------------------------------------

  const handleTransition = async (toStatus) => {

    try {

      await axiosClient.post("/api/ipe/workflow/change-status", {
        module_code: "IPE",
        entity_name: "ENQUIRY",
        entity_id: enquiry.id,
        current_status: enquiry.status_code,
        new_status: toStatus,
      });

      // reload enquiry
      const res = await axiosClient.get(`/api/ipe/enquiries/${enquiryId}`);
      const updated = res.data.data;

      setEnquiry(updated);
      loadTransitions(updated.status_code);

    } catch (err) {
      alert(err?.response?.data?.message || "Transition failed");
    }

  };

  useEffect(() => {

    async function load() {

      try {

        const res = await axiosClient.get(`/api/ipe/enquiries/${enquiryId}`);

        const found = res.data.data;

        setEnquiry(found || null);

        if (found) {
          await loadItems();
           //await loadBOMHeaders();
           await loadBOMHeaders(found.id);   // 🔥 CRITICAL FIX
           console.log("CALLING loadBOMHeaders...");

          loadTransitions(found.status_code); // ✅ important
          loadAccessControl(); // ✅ ADD THIS
        }

      } finally {
        setLoading(false);
      }

    }

    load();

  }, [enquiryId]);


  // ------------------------------------------------------------------
  // Load Variant Map
  // ------------------------------------------------------------------

  useEffect(() => {

    async function loadVariants() {

      const res = await axiosClient.get("/api/ppe/masters/product-variants");

      const map = {};

      (res.data.data || []).forEach(v => {
        map[v.id] = `${v.variant_code} – ${v.variant_name}`;
      });

      setVariantMap(map);

    }

    loadVariants();

  }, []);

  // ------------------------------------------------------------------
// Load Equipment Map
// ------------------------------------------------------------------

useEffect(() => {

  async function loadEquipment() {

    const res = await axiosClient.get("/api/ppe/masters/equipment");

    const map = {};

    (res.data.data || []).forEach(e => {
      map[e.id] = e.code || e.equipment_code || e.name || e.equipment_name;
    });

    setEquipmentMap(map);

  }

  loadEquipment();

}, []);


  if (loading) return <div>Loading enquiry…</div>;
  if (!enquiry) return <div>Enquiry not found</div>;


  // ------------------------------------------------------------------
  // KPI calculations
  // ------------------------------------------------------------------

  const totalQty = items.reduce(
    (sum, i) => sum + (Number(i.quantity) || 0),
    0
  );

  const bomItemCount = items.filter(
  (i) => i.bom_id || i.has_bom || i.bom_status
).length;

  const momItemCount = items.filter(
  (i) => i.mom_id || i.has_mom || i.mom_status
).length;


  // ------------------------------------------------------------------
  // Add Item helpers
  // ------------------------------------------------------------------

  const nextSeq =
    items.length > 0
      ? Math.max(...items.map((i) => i.item_seq_no)) + 1
      : 1;


  const openAddItem = async () => {

    setNewItem({
      item_seq_no: nextSeq,
      product_family_id: "",
      product_variant_id: "",
      quantity: "",
      priority: 3,
    });

    const pfRes = await axiosClient.get("/api/ppe/masters/product-families");

    setProductFamilies(pfRes.data.data || []);
    setProductVariants([]);

    setShowAddItem(true);

  };


  const onProductFamilyChange = async (familyId) => {

  setNewItem({
    ...newItem,
    product_family_id: familyId,
    product_variant_id: "",
    equipment_id: "",
  });

  if (!familyId) {
    setProductVariants([]);
    setEquipmentList([]);
    return;
  }

  // Load variants
  const resVariant = await axiosClient.get(
    "/api/ppe/masters/product-variants",
    { params: { product_family_id: familyId } }
  );

  setProductVariants(resVariant.data.data || []);

  // Load equipment
  const resEquipment = await axiosClient.get(
    "/api/ppe/masters/equipment",
    { params: { product_family_id: familyId } }
  );

  setEquipmentList(resEquipment.data.data || []);

};


//  const saveEnquiryItem = async () => {
//
//    await ipeEnquiryService.createEnquiryItem(enquiryId, {
//      item_seq_no: newItem.item_seq_no,
//      product_variant_id: newItem.product_variant_id,
//      quantity: newItem.quantity,
//      priority: newItem.priority,
//      status_id: 1,
//    });

const saveEnquiryItem = async () => {

  await ipeEnquiryService.createEnquiryItem(enquiryId, {
    item_seq_no: newItem.item_seq_no,
    product_family_id: newItem.product_family_id,
    product_variant_id: newItem.product_variant_id,
     equipment_id: newItem.equipment_id,
    quantity: newItem.quantity,
    priority: newItem.priority
  });


    setShowAddItem(false);

    await loadItems();

  };


  // ------------------------------------------------------------------
  // Save Product Variant
  // ------------------------------------------------------------------

  const saveProductVariant = async () => {

    const res = await axiosClient.post(
      "/api/ppe/masters/product-variants",
      {
        product_family_id: newItem.product_family_id,
        variant_code: newVariant.variant_code,
        variant_name: newVariant.variant_name,
        variant_type: "STANDARD",
        uom_id: 1,
        drawing_required: false,
        is_active: true,
        status_id: 1,
        tenant_id: enquiry.tenant_id,
        location_id: enquiry.location_id,
        created_by: enquiry.created_by,
      }
    );

    const created = res.data;

    if (!created || !created.id) return;

    setProductVariants((prev) => [...prev, created]);

    setNewItem((prev) => ({
      ...prev,
      product_variant_id: String(created.id),
    }));

    setShowAddVariant(false);

  };

  // --------------------------------------------------
// EXTRACT BOM HEADERS FROM ITEMS
// --------------------------------------------------

  console.log("BOM HEADERS:", bomHeaders);
  // ------------------------------------------------------------------
  // Render
  // ------------------------------------------------------------------

  return (
    <div>

      {/* HEADER */}

      <div
        style={{
          background: "linear-gradient(90deg, #5f0cff, #7b2cff)",
          borderRadius: 14,
          padding: "16px 22px",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
        }}
      >

        <div>
          <div style={{ fontSize: 20, fontWeight: 700 }}>
            Enquiry {enquiry.enquiry_no}
          </div>

          <div style={{ fontSize: 13, opacity: 0.9 }}>
            {enquiry.customer_name}
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>

          {/* STATUS */}
          <div
            style={{
              background: "#fff",
              color: "#5f0cff",
              padding: "6px 12px",
              borderRadius: 20,
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            {enquiry.status_code || "N/A"}
          </div>

          {/* ACTION BUTTONS */}
          {allowedTransitions.map((t) => (
            <button
              key={t.status_code}
              onClick={() => handleTransition(t.status_code)}
              style={{
                background: "#fff",
                color: "#5f0cff",
                border: "none",
                borderRadius: 8,
                padding: "6px 12px",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              {t.status_name}
            </button>
          ))}

          {/* BACK BUTTON */}
          <button
            onClick={() => navigate("/ipe/enquiries")}
            style={{
              background: "#fff",
              color: "#5f0cff",
              border: "none",
              borderRadius: 8,
              padding: "8px 14px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            ← Back
          </button>

        </div>

      </div>


      {/* KPI ROW */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: 16,
          marginBottom: 24,
        }}
      >

        <KpiCard title="Status" value={enquiry.status_code} />

        <KpiCard title="Enquiry Items" value={items.length} />

        <KpiCard title="Total Quantity" value={totalQty} />

        <KpiCard
          title="BOM Progress"
          value={`${bomItemCount} / ${items.length}`}
        />

        <KpiCard
          title="MOM Progress"
          value={`${momItemCount} / ${items.length}`}
        />

      </div>


      {/* TABS */}

      <ul className="nav nav-tabs">
      {["OVERVIEW","ITEMS", "BOM", "MAPPING","MOM", "MATERIAL_OPERATION", "COSTING",  "SELLING_COSTING",  "QUOTATION"].map((t) => {

        const isDisabled =
          (t === "bom" && !accessControl?.bom?.view) ||
          (t === "mom" && !accessControl?.mom?.view) ||
          (t === "costing" && !accessControl?.costing?.view);

        return (
          <li className="nav-item" key={t}>
            <button
              className={`nav-link ${
                activeTab === t && t !== "COSTING" && t !== "SELLING_COSTING"
                  ? "active"
                  : ""
              }`}
              disabled={isDisabled}
              title={isDisabled ? "Access denied" : ""}
              onClick={() => {

                // 🚫 block click if no access
                if (isDisabled) return;

                if (t === "COSTING") {
                  setShowCosting(true);
                  return;
                } 
                else if (t === "SELLING_COSTING") {
                  setShowSellingCost(true);
                  return;
                }
                else if (t === "QUOTATION") {
                  setShowQuotation(true);
                  return;
                } 
                else {
                  setActiveTab(t);
                }
              }}
            >
              {t === "material-operation" ? "Material-Operation" : t.toUpperCase()

              }
            </button>
          </li>
        );
      })}
    </ul>


    {/* TAB CONTENT */}

    <div className="border border-top-0 p-3">

      {activeTab === "OVERVIEW" && (
        <div className="container-fluid">

          {/* 🔵 ENQUIRY SUMMARY */}
          <div className="card mb-3 shadow-sm border-0">

            <div
              style={{
                background: "linear-gradient(90deg, #5f0cff, #7b2cff)",
                color: "#fff",
                borderRadius: "10px 10px 0 0",
                padding: "12px 16px",
                fontWeight: 600,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <span>Enquiry Summary</span>

              <button
                className="btn btn-sm btn-light"
                style={{ fontWeight: 600 }}
              >
                Edit
              </button>
            </div>

            <div className="card-body">
              <div className="row align-items-center">

                <div className="col-md-4 mb-3">
                  <small className="text-muted">Enquiry No</small>
                  <div style={{ fontSize: 18, fontWeight: 600 }}>
                    📄 {enquiry.enquiry_no}
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <small className="text-muted">Customer</small>
                  <div style={{ fontSize: 18, fontWeight: 600 }}>
                    👤 {enquiry.customer_name || "-"}
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <small className="text-muted">Status</small>
                  <div>
                    <span className="badge bg-primary px-3 py-2">
                      {enquiry.status_code || "-"}
                    </span>
                  </div>
                </div>

              </div>
            </div>
          </div>


          {/* 🟣 ENQUIRY DETAILS (NEW) */}
          <div className="card mb-3 shadow-sm border-0">

            <div className="card-header fw-semibold">
              Enquiry Details
            </div>

            <div className="card-body">
              <div className="row">

                <div className="col-md-3 mb-3">
                  <small className="text-muted">Enquiry Type</small>
                  <div className="fw-semibold">
                    {enquiry.enquiry_type_name || "-"}
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <small className="text-muted">Priority</small>
                  <div className="fw-semibold">
                    {enquiry.priority_name || "-"}
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <small className="text-muted">Industry</small>
                  <div className="fw-semibold">
                    {enquiry.industry_name || "-"}
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <small className="text-muted">Application Type</small>
                  <div className="fw-semibold">
                    {enquiry.application_type_name || "-"}
                  </div>
                </div>

              </div>
            </div>
          </div>


          {/* 🟢 BUSINESS DETAILS (ENHANCED) */}
          <div className="card mb-3 shadow-sm border-0">

            <div className="card-header fw-semibold d-flex justify-content-between">
              <span>Business Details</span>
            </div>

            <div className="card-body">
              <div className="row">

                <div className="col-md-3 mb-3">
                  <small className="text-muted">Project Reference</small>
                  <div className="fw-semibold">
                    {enquiry.project_reference || "-"}
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <small className="text-muted">Plant Capacity</small>
                  <div className="fw-semibold">
                    {enquiry.plant_capacity || "-"}
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <small className="text-muted">Project Location</small>
                  <div className="fw-semibold">
                    {enquiry.project_location || "-"}
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <small className="text-muted">Enquiry Date</small>
                  <div className="fw-semibold">
                    {enquiry.enquiry_date
                      ? new Date(enquiry.enquiry_date).toLocaleDateString()
                      : "-"}
                  </div>
                </div>

                <div className="col-md-3 mb-3">
                  <small className="text-muted">Expected Response</small>
                  <div className="fw-semibold">
                    {enquiry.expected_response_date
                      ? new Date(enquiry.expected_response_date).toLocaleDateString()
                      : "-"}
                  </div>
                </div>

              </div>
            </div>
          </div>


          {/* 🟡 REMARKS */}
          <div className="card shadow-sm border-0">

            <div className="card-header fw-semibold">
              Remarks
            </div>

            <div
              className="card-body"
              style={{
                background: "#f8f9fa",
                borderRadius: 8,
                minHeight: 60
              }}
            >
              {enquiry.remarks ? (
                <div style={{ whiteSpace: "pre-line" }}>
                  📝 {enquiry.remarks}
                </div>
              ) : (
                <div className="text-muted">
                  No remarks added
                </div>
              )}
            </div>

          </div>

        </div>
      )}
      
      
      
      {activeTab === "ITEMS" && (
        <>
          <div className="d-flex justify-content-between mb-3">
            <div className="fw-semibold">Enquiry Items</div>

            <button
              className="btn btn-primary btn-sm"
              onClick={openAddItem}
              disabled={accessControl?.read_only}
            >
              + Add Item
            </button>
          </div>

          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Seq</th>
                <th>Variant</th>
                <th>Equipment</th>
                <th>Qty</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {items.map((i) => (
                <tr key={i.id}>
                  <td>{i.item_seq_no}</td>
                  <td>
                    {variantMap[i.product_variant_id] ||
                      `Variant #${i.product_variant_id}`}
                  </td>
                  <td>
                    {equipmentMap[i.equipment_id] ||
                      `Equipment #${i.equipment_id}`}
                  </td>
                  <td>{i.quantity}</td>
                  <td>{i.status_code || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}

      {activeTab === "BOM" &&
        accessControl?.bom?.view && (
          <>

            {/* 🔥 ORIGINAL EDITABLE BOM (RESTORE THIS) */}
            {items.map((item) => (
              <EngineeringBOMCard
                key={item.id}
                item={item}
                readOnly={accessControl?.read_only || !accessControl?.bom?.edit}
                onBOMCreated={() => loadBOMHeaders(enquiry.id)}
              />
            ))}

            {/* 🔥 ACTION BUTTON */}
            <div className="d-flex justify-content-end mt-3">
              <button
                className="btn btn-warning btn-sm"
                onClick={handleGenerateAllDerived}
              >
                ⚙️ Generate Derived
              </button>
            </div>

            {/* 🔥 NEW STRUCTURED VIEW (READ ONLY BELOW) */}
            <hr />

            {bomHeaders.length === 0 ? (
              <div className="text-center text-muted mt-3">
                No BOM found for this enquiry
              </div>
            ) : (
              bomHeaders.map((bom) => (
                <div key={bom.id} className="mb-4">
                  <div className="fw-bold mb-2">
                    📦 {bom.code || `BOM-${bom.id}`}
                  </div>

                  <EngineeringBOMStructuredView bomId={bom.id} />
                </div>
              ))
            )}

          </>
      )}
      {activeTab === "MAPPING" && (
        <ManufacturerMappingScreen 
          enquiryItems={items}
          bomList={bomHeaders}
        />
      )}

      {activeTab === "MOM" &&
        accessControl?.mom?.view && (
          <EngineeringMOMView
            items={items}
            readOnly={accessControl?.read_only || !accessControl?.mom?.edit}
          />
        )}

      {activeTab === "MATERIAL_OPERATION" && (
        <>
          <div className="mb-3">

            <label className="form-label fw-semibold">
              Select Item
            </label>

            <select
              className="form-select"
              value={selectedMappingItemId || ""}
              onChange={(e) =>
                setSelectedMappingItemId(Number(e.target.value))
              }
              disabled={accessControl?.read_only}
            >
              <option value="">-- Select Item --</option>

              {items.map((i) => (
                <option key={i.id} value={i.id}>
                  Item #{i.item_seq_no} —{" "}
                  {variantMap[i.product_variant_id] ||
                    `Variant #${i.product_variant_id}`}
                </option>
              ))}

            </select>

          </div>

          {selectedMappingItemId && (
            <BOMOperationMappingView
              enquiryItemId={selectedMappingItemId}
              readOnly={accessControl?.read_only}
            />
          )}
        </>
      )}

    </div>

      {/* ADD ITEM MODAL */}
            {/* ADD ITEM MODAL */}

            {showAddItem && (
              <div className="modal fade show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
                <div className="modal-dialog">
                  <div className="modal-content">

                    <div className="modal-header">
                      <h5 className="modal-title">Add Enquiry Item</h5>
                      <button
                        className="btn-close"
                        onClick={() => setShowAddItem(false)}
                      />
                    </div>

                    <div className="modal-body">

                      <div className="mb-3">
                        <label className="form-label">Product Family</label>
                        <select
                          className="form-select"
                          value={newItem.product_family_id}
                          onChange={(e) => onProductFamilyChange(e.target.value)}
                        >
                          <option value="">Select Family</option>
                          {productFamilies.map((pf) => (
                            <option key={pf.id} value={pf.id}>
                              {pf.family_name || pf.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Product Variant</label>
                        <select
                          className="form-select"
                          value={newItem.product_variant_id}
                          onChange={(e) =>
                            setNewItem({
                              ...newItem,
                              product_variant_id: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Variant</option>
                          {productVariants.map((pv) => (
                            <option key={pv.id} value={pv.id}>
                              {pv.variant_code} – {pv.variant_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Equipment</label>

                        <select
                          className="form-select"
                          value={newItem.equipment_id}
                          onChange={(e) =>
                            setNewItem({
                              ...newItem,
                              equipment_id: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Equipment</option>

                          {equipmentList.map((eq) => (
                            <option key={eq.id} value={eq.id}>
                              {eq.code || eq.equipment_code || eq.name || eq.equipment_name}
                            </option>
                          ))}

                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Quantity</label>
                        <input
                          type="number"
                          className="form-control"
                          value={newItem.quantity}
                          onChange={(e) =>
                            setNewItem({
                              ...newItem,
                              quantity: e.target.value,
                            })
                          }
                        />
                      </div>

                    </div>

                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setShowAddItem(false)}
                      >
                        Cancel
                      </button>

                      <button
                        className="btn btn-primary"
                        onClick={saveEnquiryItem}
                      >
                        Save Item
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            )}


            {/* COSTING DRAWER */}
            {showCosting && (
              <CostingOverlayDrawer
                enquiryId={enquiryId}
                onClose={() => setShowCosting(false)}
              />
            )}
            {showSellingCost && (
              <SellingCostingOverlayDrawer
                enquiryId={enquiryId}
                onClose={() => setShowSellingCost(false)}
              />
            )}
            {showQuotation && (
              <SellingQuotationOverlayDrawer
                enquiryId={enquiryId}
                onClose={() => setShowQuotation(false)}
              />
            )}


          </div>

        );
      }  